import styled from 'styled-components';
import PropTypes from 'prop-types';

const HelperIcon = ({ dataFor }) => {
  return (
    <A data-tip data-for={dataFor}>
      <Icon />
    </A>
  );
};

HelperIcon.propTypes = {
  dataFor: PropTypes.string.isRequired,
};

export default HelperIcon;

const A = styled.a`
  color: ${props => props.theme.input.label.fontColor};
`;

const Icon = styled.div`
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 500;
  user-select: none;
  cursor: help;

  &:after {
    content: '?';
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1.125rem;
    width: 1.125rem;
    border: 0.125rem solid ${props => props.theme.input.label.fontColor};
    border-radius: 50%;
  }

  div {
  }
`;
